// src/plugins/vuetify.js

import Vue from 'vue';
import Vuetify from 'vuetify';
import 'vuetify/dist/vuetify.min.css';
import '@mdi/font/css/materialdesignicons.css'; // Ensure you are using css-loader

Vue.use(Vuetify);

const opts = {
  theme: {
    themes: {
      light: {
        primary: '#4646ab',
        primaryDark: '#384955',
        black: '#111827',
        grayDark: '#384955',
        grayLight: '#6b7280',
        scrollbarColor: '#e9e9e9',
        newAppBar: '#4646ab',
        brightPurple: '#4F46E5',
      },
    },
  },
  icons: {
    iconfont: 'mdi', // default - only for display purposes
  },
};

export default new Vuetify(opts);
